import React, { useState, useCallback } from "react";

import WhenComponent from "./WhenComponent";
import AdDesignComponent from "./AdDesignComponent";
import CampaignForm from "./CampaignForm";
import WhoComponent from "./WhoComponent";

import calenderIcon from "../../../assets/images/marketing/calender.png";
import publishIcon from "../../../assets/images/marketing/publish.png";
import userIcon from "../../../assets/images/marketing/user.png";
import documentIcon from "../../../assets/images/marketing/document.png";

const ICONS = [userIcon, calenderIcon, documentIcon, publishIcon];
const ICON_LABELS = ['WHO','WHEN', 'WHAT', 'PUBLISH'];
const ICON_ALTS = ['User Icon', 'Calender Icon', 'Document Icon', 'Publish Icon'];

const getIconColor = (currentIndex, selectedIndex) => {
    if (selectedIndex === null) return 'grey';
    return currentIndex <= selectedIndex ? 'black' : 'grey';
}

const getLineColor = (currentIndex, selectedIndex) => {
    if (selectedIndex === null) return 'grey';
    if (currentIndex === ICONS.length - 1 && selectedIndex === ICONS.length - 1) return '#CC1977';
    if (currentIndex <= selectedIndex) return '#CC1977';
    return 'grey';
}

const SalesGrowth = () => {
    const [selectedIcon, setSelectedIcon] = useState(0);
    const [selectedOption, setSelectedOption] = useState('url');
    const [campaignData, setCampaignData] = useState({
        selectedApp: null,
        selectedDeviceOS: null,
        selectedTrigger: null,
        selectedAudience: null,
        timeRanges: [],
        isRichNotification: false,
        notificationTitle: 'Veloxity Notification Title',
        notificationBody: 'Veloxity Notification Message',
        url: '',
        deepLink: '',
        selectedButtons: ['accept'],
        selectedLanguage: null,
        selectedFile: null
    });
    
    // Veri güncelleme fonksiyonu - useCallback ile sarmalayarak her render'da yeniden oluşturulmasını engelliyoruz
    const updateCampaignData = useCallback((newData) => {
        setCampaignData(prevData => ({
            ...prevData,
            ...newData
        }));
    }, []);

    const handleSubmit = async () => {
        // Kampanya verilerini hazırla
        const campaignData = {
            name: formData.name,
            description: formData.description,
            campaignType: formData.campaignType,
            // eventDefinition'ı kampanya tipine göre ayarla
            eventDefinition: formData.eventDefinition,
            // Diğer veriler...
        };
        
        try {
            // API'ye gönder
            const response = await api.post('/campaigns', campaignData);
            // Başarılı yanıt işleme...
        } catch (error) {
            // Hata işleme...
        }
    };

    document.title = "AIMEE - Create Campaign";
    return (
        <React.Fragment>
            <div className="page-content">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative' }}>
                    {ICONS.map((icon, index) => (
                        <div key={index} className="icon-container" style={{ textAlign: 'center', flex: 1, position: 'relative' }}>
                            <div style={{ marginBottom: '10px', display: 'inline-block' }}>
                                <img
                                    src={icon}
                                    alt={ICON_ALTS[index]}
                                    style={{
                                        width: '50px',
                                        height: '50px',
                                        cursor: 'pointer',
                                        filter: getIconColor(index, selectedIcon) === 'grey' ? 'grayscale(100%)' : 'none'
                                    }}
                                    onClick={() => setSelectedIcon(index)}
                                />
                                <div style={{ marginTop: '5px' }}>{ICON_LABELS[index]}</div>
                            </div>
                            {index !== ICONS.length - 2 && (
                                <div className="connection-line" style={{
                                    position: 'absolute',
                                    top: '30%',
                                    right: '0',
                                    left: 'calc(60%)',
                                    height: '2px',
                                    backgroundColor: getLineColor(index, selectedIcon),
                                    transform: 'translateY(-50%)'
                                }} />
                            )}
                            {index !== 0 && (
                                <div className="connection-line" style={{
                                    position: 'absolute',
                                    top: '30%',
                                    left: 'calc(-40%)',
                                    right: 'calc(60%)',
                                    height: '2px',
                                    backgroundColor: getLineColor(index, selectedIcon),
                                    transform: 'translateY(-50%)'
                                }} />
                            )}
                            {index === 0 && (
                                <div className="connection-line" style={{
                                    position: 'absolute',
                                    top: '30%',
                                    left:'calc(0%)',
                                    right: 'calc(60%)',
                                    height: '2px',
                                    backgroundColor: getLineColor(index, selectedIcon),
                                    transform: 'translateY(-50%)'
                                }} />
                            )}
                        </div>
                    ))}

                </div>
                {selectedIcon === 0 && (
                    <WhoComponent 
                        setSelectedIcon={setSelectedIcon} 
                        updateCampaignData={updateCampaignData}
                        campaignData={campaignData}
                    />
                )}
                {selectedIcon === 1 && (
                    <WhenComponent 
                        setSelectedIcon={setSelectedIcon} 
                        updateCampaignData={updateCampaignData}
                        campaignData={campaignData}
                    />
                )}
                {selectedIcon === 2 && (
                    <AdDesignComponent
                        selectedIcon={selectedIcon}
                        setSelectedIcon={setSelectedIcon}
                        selectedOption={selectedOption}
                        setSelectedOption={setSelectedOption}
                        updateCampaignData={updateCampaignData}
                        campaignData={campaignData}
                    />
                )}
                {selectedIcon === 3 && (
                    <CampaignForm 
                        setSelectedIcon={setSelectedIcon} 
                        campaignData={campaignData}
                    />
                )}
            </div>
        </React.Fragment>
    );
};

export default SalesGrowth;